/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Loader from 'react-loader-spinner'
import CardContent from '../CardContent'
import {
  getPesticidesRequest, getPesticideFilterRequest,
  resetFilter,
} from '../../../redux-saga/User/AllPesticide/Reducer'
import { getCategoryRequest } from '../../../redux-saga/User/AllCategory/Reducer'
import style from './index.module.css'
import Search from '../../../components/Mobile/Search'
import SpinLoader from '../../../components/Mobile/Loader'
import ErrorMessage from '../../../components/Mobile/ErrorMessage'

const Pesticide = () => {
  const dispatch = useDispatch()
  const [ searchString, setSearchString ] = useState('')
  const {
    pesticides, fetching, filterFetching, filteredPesticide,
    isFilterEnabled,
  } = useSelector((state) => state.pesticides)
  const { categories } = useSelector((state) => state.categories)
  useEffect(() => {
    dispatch(getCategoryRequest())
    dispatch(getPesticidesRequest())
  }, [])

  const onSearch = (e) => {
    const { value } = e.target
    setSearchString(e.target.value)
    if (!value?.length) {
      dispatch(resetFilter())
    }
  }
  const onSearchSubmit = () => {
    dispatch(getPesticideFilterRequest({ text: searchString }))
  }
  const clearSearch = () => {
    setSearchString('')
    dispatch(resetFilter())
  }

  return (
    <>
      <Search
        onSearchChange={ onSearch }
        value={ searchString }
        onSearchHandler={ onSearchSubmit }
        clearSearch={ clearSearch }
      />
      {
        (fetching || filterFetching)
          ? (
            <SpinLoader />
          )
          : (isFilterEnabled && !filterFetching)
            ? (filteredPesticide?.length)
              ? <CardContent pesticides={ filteredPesticide } />
              : <ErrorMessage message='No result found !! Please try with pesticide name, category, brand, season' />
            : pesticides?.length > 0 && <CardContent pesticides={ pesticides } />
      }
    </>
  )
}

export default Pesticide
